'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDiadem, iconDiademTag } from '@ni/nimble-components/dist/esm/icons/diadem';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDiadem };
export { iconDiademTag };
export const NimbleIconDiadem = wrap(IconDiadem);